import { StreamingServicesUtil } from '../../utils/streaming-services.util';
var ɵ0 = function (stateService) {
    return stateService.selectSnapshot(function (state) { return !state.customer.isEligibleForStreamingBundles; });
};
var HeroBanner = {
    componentId: 'hero-banner',
    shouldShowComponent: false,
    process: (ɵ0)
};
var ɵ1 = function (stateService) {
    return stateService.selectSnapshot(function (state) { return state.customer.isEligibleForStreamingBundles; });
};
var HeroStreamingBundleCarousel = {
    componentId: 'hero-streaming-bundle-carousel',
    shouldShowComponent: false,
    process: (ɵ1)
};
var ɵ2 = function (stateService) {
    var streamingServices = stateService.selectSnapshot(function (state) { return state.tvShopStreamingServices; });
    var standaloneStreamingServicesInCarousel = StreamingServicesUtil.getStandAloneStreamingServices(streamingServices);
    var showCard = stateService.selectSnapshot(function (state) { return state.customer.isEligibleForStreamingBundles; });
    var isSoho = stateService.selectSnapshot(function (state) { return state.customer.isSohoCustomer; });
    return showCard && standaloneStreamingServicesInCarousel.length > 0 && !isSoho;
};
var StandaloneStreamingCarousel = {
    componentId: 'standalone-streaming-carousel',
    shouldShowComponent: false,
    process: (ɵ2)
};
var ɵ3 = function (stateService) {
    var packs = stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
    return packs.length > 0;
};
var ProductCarousel = {
    componentId: 'product-carousel',
    shouldShowComponent: false,
    process: (ɵ3)
};
export var NavigableComponentConfigurationHomePage = {
    title: 'Shop',
    navigableComponents: [
        HeroBanner,
        HeroStreamingBundleCarousel,
        ProductCarousel,
        StandaloneStreamingCarousel
    ]
};
export { ɵ0, ɵ1, ɵ2, ɵ3 };
